import React, { PureComponent } from 'react';
import { createSessionFromFile } from 'data/session';
// Components
import From, { TextField } from 'ui/form';
import Dropzone from 'ui/dropzone';
import Button from 'ui/button';
import { LoaderOverlay } from 'ui/loader';
import styles from './create.scss';
import Card from 'ui/card';
import { RouteComponentProps } from 'react-router-dom';
interface SessionCreateProps extends RouteComponentProps {}
export default class SessionCreate extends PureComponent<SessionCreateProps> {
  state = {
    uploading: false,
    error: false
  };
  handleDrop = async([file]) => {
    try {
      this.setState({ uploading: true, error: false });
      const { key } = await createSessionFromFile(file);
      this.props.history.push('/session/' + key);
    } catch (e) {
      console.error('Failed to create', e);
      this.setState({ uploading: false, error: e });
    }
  };

  render() {
    return (
      <div className="center-content">
        <LoaderOverlay show={this.state.uploading} message="Uploading file" />
        <Card className="margin">
          <Dropzone
            onDrop={this.handleDrop}
            className={styles.dropzone}
            error={this.state.error && 'Failed to create session, maybe try again?'}
            header="Drop session file to convert"
          />
        </Card>
      </div>
    );
  }
}
